import LayoutPublicHeader from '@/layouts/PublicLayout/components/PublicHeader';
import { Helmet } from 'react-helmet';

import './style.less';
import { Typography } from 'antd';

const PrivacyPolicyPage: React.FC = () => {
  return (
    <>
      <Helmet title="Política de Privacidade | Ultracar" />

      <LayoutPublicHeader />

      <div className="privacy-policy-container">
        <Typography.Title level={2}>
          Política de privacidade do Ultracar
        </Typography.Title>

        <p>
          A Ultracar é uma empresa íntegra e segue à risca a LGPD - Lei Geral de
          Proteção de Dados, garantindo que todos os seus clientes tenham suas
          informações sempre seguras em qualquer hipótese. Sendo assim, todos e
          quaisquer dados cedidos pelos clientes são feitos com consentimento e
          são usados apenas para a finalidade acordada no momento da contratação
          da plataforma.
        </p>

        <Typography.Title level={3}>
          Dúvidas frequentes sobre o Ultracar
        </Typography.Title>

        <Typography.Title level={4}>
          Como funciona o armazenamento de dados do Ultracar?
        </Typography.Title>

        <p>
          Os dados são armazenados em nuvem e todo o nosso sistema de segurança
          é desenvolvido seguindo as instruções mais modernas e a LGPD.
        </p>

        <Typography.Title level={4}>
          Como funciona o backup? Posso perder tudo?
        </Typography.Title>

        <p>
          Por conta do armazenamento em nuvem, é possível realizar o backup e
          garantir que as informações estejam sempre a salvo. Porém, isso deverá
          ser configurado pelo usuário.
        </p>

        <Typography.Title level={4}>
          Por que um sistema em nuvem é mais seguro do que um sistema de
          instalação da máquina?
        </Typography.Title>

        <p>
          Normalmente, empresas que fornecem um sistema de nuvem possuem muitos
          especialistas dedicados na parte de segurança de dados. Já em
          instalação de máquinas, depende da especificações técnicas da máquina,
          bem como do nível de segurança do programa, que pode ser hackeado ou
          infectado com vírus.
        </p>

        <Typography.Title level={4}>
          Quais os pré-requisitos para acessar o Ultracar?
        </Typography.Title>

        <p>
          Para utilizar o Ultracar, você não precisa instalar nenhum programa.
          Basta ter uma conexão estável com a internet para acessá-lo via
          smartphone, tablet ou computador.
        </p>
      </div>
    </>
  );
};

export default PrivacyPolicyPage;
